__turbopack_context__.v({
  "fbBtn": "styles-module-scss-module__oRz1Oa__fbBtn",
});
